import {defineMessages} from "react-intl";

export const cart_item_translations = defineMessages({
    summary: {id:"detail", defaultMessage : "Détails"},
    price_amount: {id:"price-amount", defaultMessage : "Prix unitaire"},
    price_immediate_account: { id:"price-immediat-account", defaultMessage : "À payer maintenant"},
    empty_card_nothing_found: { id:"empty-cart-nothing-found",defaultMessage : "Vous n'avez encore rien trouvé ?"},
    empty_card_explore: {id:"empty-cart-explore-accomodations", defaultMessage : "Parcourez tous les hébergements disponibles."},
});